<template>
	<div class="city-select" @click.prevent="open">
		<slot />
		<template>
			<v-modal ref="modal" title="выбор города" portal="modal-city-select">
				<div class="branches-grid">
					<div v-for="(branche, slug) in branches" :key="slug">
						<a :class="{ active: branch === slug }" :href="`/city-select/${slug}?refer=${refer}`">{{
							branche.title
						}}</a>
					</div>
				</div>
			</v-modal>
		</template>
	</div>
</template>

<script>
import Modal from './Modal/index.vue';
export default {
	data() {
		return {
			branch: window.branch,
			branches: window.branches
		};
	},
	computed: {
		refer() {
			return window.location.pathname;
		}
	},
	components: {
		'v-modal': Modal
	},
	methods: {
		open() {
			this.$refs['modal'].modalOpen();
		}
	}
};
</script>

<style lang="scss">
.city-select {
	display: inline-block;
	cursor: pointer;
	span {
		text-decoration: none;
		color: #fff;
		font-size: 15px;
	}
	&:hover {
		opacity: 0.78;
	}
}
.app-modal {
	.app-modal-content {
		max-width: 600px;
		.app-modal-title {
			margin-bottom: 20px;
		}
	}
}
.branches-grid {
	display: grid;
	grid-template-columns: 1fr 1fr;
	a {
		font-size: 22px;
		line-height: 130%;
		/* or 29px */

		color: #000000;

		opacity: 0.6;
		&:hover {
			opacity: 1;
		}
		&.active {
			font-weight: bold;
			/* or 29px */
			color: #ff0000;
		}
	}
}
</style>
